import { MultiMediaReponseType } from '../../../utils/types';
import CustProductCard from '../CustProductCard';
import QuickOptionCard from '../QuickOptionCard';
import UploadCard from '../UploadCard';
import VideoCard from '../VideoCard';

interface MultimediaResponseCardProps {
  multiMediaResponse: MultiMediaReponseType & { [key: string]: any };
  actions: any;
}
const MultimediaResponseCard = ({
  multiMediaResponse,
  actions,
}: MultimediaResponseCardProps) => {
  switch (multiMediaResponse.type) {
    case 'product':
      return <CustProductCard product={multiMediaResponse} />;
    case 'video':
      return <VideoCard video={multiMediaResponse} />;
    case 'user_options':
      return <QuickOptionCard options={multiMediaResponse} actions={actions} />;
    case 'image_upload':
      return (
        <UploadCard
          upload={multiMediaResponse}
          actions={actions}
          fileType="image"
        />
      );
    case 'document_upload':
      return (
        <UploadCard
          upload={multiMediaResponse}
          actions={actions}
          fileType="document"
        />
      );
    default:
      return null;
  }
};

export default MultimediaResponseCard;
